// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import LazyLoad from './Classes/Lazyload';
import Sticky from '../../node_modules/sticky-js';
import ResponsiveTable from "./Classes/ResponsiveTable";
import Toggler from './Classes/Toggler';
// import Navigation from './Classes/Navigation';
import SetTargetBlank from './Classes/SetTargetBlank';
import FootnoteSpan from './Classes/FootnoteSpan';
import Gri from './Classes/Gri';
import Header from './Classes/Header';
import Video from './Classes/Video';
import Search from './Classes/Search';

module.exports = NSTheme;

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    // new Navigation({
    //   menuTogglerSelector: '.burger',
    //   openButtonSelector: '.search-toggle',
    //   togglingContainerSelector: '.site-search'
    // });


    new Video();

    new Header({
      mobileNavToggleSelector: '.js-toggle-main-menu',
      mainMenuContainerSelector: '.header__menu',
      submenuToggleSelector: '.js-nav-dropdown-toggler',
      submenuBackToggleSelector: '.js-menu-item-back',
      searchOpenSelector: '.js-search-trigger',
      searchCloseSelector: '.js-search-close',
    });

    new Search({
      closeButtonSelector: '.search-close',
      openButtonSelector: '.search-toggle',
      togglingContainerSelector: '.site-search'
    });

    new Toggler({
      togglerButtonSelector: '.ns-portrait__readmore-toggle',
      togglerContainerSelector: '.ns-portait__readmore-content'
    });

    new FocusHandler();

    new Accordion({
      accordions: '.js-toggle-accordion'
    });

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new LazyLoad();

    if (Helper.isDesktop()) {
      new Sticky('.header__bottom');
    }

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    new SetTargetBlank({
      targetBlanks: '.js-anchor-target'
    });

    new FootnoteSpan({
      footnoteSelector: 'p.ns-style-footnote'
    });

    new Gri();

  })
})();
